import common from './common.json';

export const fr_CA = {
    common
};
